import { Typography } from "@mui/material";
import React from "react";

const Walkin = () => {
  return (
    <div>
      <Typography>walk-in jobs</Typography>
    </div>
  );
};

export default Walkin;
